import React from "react";
import { Spinner } from "react-bootstrap";

const Loading = ({ show }) => {
  return (
    <>
      {show ? (
        <div className="loading-box">
          <Spinner animation="grow" variant="primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Loading;
